import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=aaf97bfc&scoped=true&"
import script from "./AppMenu.vue?vue&type=script&lang=js&"
export * from "./AppMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppMenu.vue?vue&type=style&index=0&id=aaf97bfc&prod&lang=scss&scoped=true&"
import style1 from "./AppMenu.vue?vue&type=style&index=1&id=aaf97bfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf97bfc",
  null
  
)

export default component.exports